/* One delegated click per real link, including native Enter-key activation. */
(() => {
  if (window.__zmPairsClickBound) return;
  window.__zmPairsClickBound = true;
  document.addEventListener('click', (event) => {
    const link = event.target instanceof Element
      ? event.target.closest('[data-zm-pair-link]') : null;
    if (!link) return;
    const privacy = window.Shopify?.customerPrivacy;
    if (typeof privacy?.analyticsProcessingAllowed === 'function'
      && !privacy.analyticsProcessingAllowed()) return;
    const data = {
      pair_direction: link.dataset.direction,
      source_product_id: link.dataset.sourceId,
      target_product_id: link.dataset.targetId,
      recommendation_rank: Number(link.dataset.rank),
      placement: 'product_pairs_well_with',
    };
    // Use the existing consent-managed Google configuration; no new tracker.
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'pairs_well_with_click', data);
    }
    if (typeof window.Shopify?.analytics?.publish === 'function') {
      window.Shopify.analytics.publish('pairs_well_with_click', data);
    }
  });
})();
